import { Section } from '@/components/shared';
import { ERRORS, ROUTE_PATHS } from '@/constants';
import { hasEmptyFields } from '@/utils';
import { Button, Flex, Link, Text } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import type { SubmitHandler } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { MbeInput } from '../shared';
import type { IManageGuestForm } from '../../types';
import type { IBaseForm } from '@/types';

export const GuestForm: React.FC<IBaseForm<IManageGuestForm>> = ({
  onSubmit: providedOnSubmit,
}): JSX.Element => {
  const { t } = useTranslation();

  const {
    formState: { errors },
    handleSubmit: submitHandler,
    register,
    watch,
  } = useForm<IManageGuestForm>({ mode: 'all', criteriaMode: 'all' });

  const isDisabled = hasEmptyFields(watch());

  const handleSubmit: SubmitHandler<IManageGuestForm> = (data, event): void => {
    event?.preventDefault();
    providedOnSubmit?.(data);
  };

  return (
    <Section containerProps={{ py: 6 }} headingProps={{ mt: 0 }} id="guest-form">
      <Flex direction="column" pb={8}>
        <Text fontSize={14} mb={8} textAlign="center">
          <Trans
            components={{
              url: <Link color="brand.red.light" fontWeight="bold" href={ROUTE_PATHS.userLogin} />,
            }}
            i18nKey={'GUEST.GUEST_FORM.DESCRIPTION'}
          />
        </Text>
        <form
          autoComplete="off"
          id="guestForm"
          name="guestForm"
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          onSubmit={submitHandler(handleSubmit)}
        >
          <Flex direction="column" gap={8}>
            <MbeInput
              error={errors.lastName}
              id="lastName"
              placeholder={t('GUEST.GUEST_FORM.LASTNAME')}
              {...register('lastName', {
                required: { value: true, message: t(ERRORS.empty) },
              })}
            />
            <MbeInput
              error={errors.id}
              id="id"
              placeholder={t('GUEST.GUEST_FORM.ID')}
              {...register('id', {
                required: { value: true, message: t(ERRORS.empty) },
              })}
            />
            <Text fontSize={11.5} mb={-4} textAlign="center">
              {t('GUEST.GUEST_FORM.AUTHORIZATION')}
            </Text>
            <Button disabled={isDisabled} type="submit" variant="mbePrimary">
              {t('LOGIN.ACTION')}
            </Button>
          </Flex>
        </form>
      </Flex>
    </Section>
  );
};
